import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Sparkles } from "lucide-react";
import { useAccount } from "@/context/AccountAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAccount();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/account");
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/account/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data);
        const dest = window.location.pathname && window.location.pathname !== "/"
          ? window.location.pathname
          : "/account";
        window.history.replaceState(null, "", dest);
        navigate(dest, { state: { user: data } });
      } catch {
        window.history.replaceState(null, "", window.location.pathname);
        navigate(window.location.pathname || "/account");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-[#0B0605] text-[#EFE3CC]"
      data-testid="auth-callback"
    >
      <Sparkles className="w-6 h-6 text-[#C9A24B] animate-pulse" strokeWidth={1.5} />
      <p className="mt-4 text-xs tracking-[0.3em] uppercase text-[#B7A488]">
        Opening the veil…
      </p>
    </div>
  );
}
